"use client";

import { useEffect } from "react";
import { onCLS, onFCP, onINP, onLCP, onTTFB, type Metric } from "web-vitals";

interface WebVitalsProps {
  /** Enable debug logging to console */
  debug?: boolean;
}

export default function WebVitals({ debug = false }: WebVitalsProps) {
  useEffect(() => {
    if (!debug) {
      return;
    }
    const logMetric = (metric: Metric) => {
      console.log(`[WebVitals] ${metric.name}: ${metric.value.toFixed(2)}`);
    };
    onCLS(logMetric);
    onFCP(logMetric);
    onINP(logMetric);
    onLCP(logMetric);
    onTTFB(logMetric);
  }, [debug]);

  return null;
}
